// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GoogleAuth = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M28.64 16.3c0-.934-.084-1.832-.24-2.694H16V18.7h7.086a6.057 6.057 0 0 1-2.627 3.974v3.304h4.255c2.49-2.292 3.926-5.668 3.926-9.678Z"
			fill="#4285F4"
		/>
		<path
			d="M16 29.167c3.555 0 6.536-1.18 8.714-3.19l-4.255-3.304c-1.18.79-2.687 1.257-4.459 1.257-3.43 0-6.332-2.316-7.367-5.428h-4.4v3.411C6.4 26.216 10.854 29.167 16 29.167Z"
			fill="#34A853"
		/>
		<path
			d="M8.633 18.502A7.915 7.915 0 0 1 8.22 16c0-.868.15-1.712.413-2.502v-3.411h-4.4A13.161 13.161 0 0 0 2.834 16c0 2.125.51 4.136 1.4 5.913l4.4-3.411Z"
			fill="#FBBC05"
		/>
		<path
			d="M16 8.07c1.933 0 3.669.664 5.033 1.97l3.777-3.777c-2.28-2.125-5.26-3.43-8.81-3.43-5.147 0-9.6 2.95-11.766 7.254l4.399 3.411C9.668 10.386 12.57 8.07 16 8.07Z"
			fill="#EA4335"
		/>
	</svg>
);
export default GoogleAuth;
